var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "27px",
    viewBox: "0 0 21 27",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "\uF3C5")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tile/store-1",
    transform: "translate(-28.000000, -445.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(23.000000, 445.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4999768,5.12504262 C18.188054,5.12504262 20.3749651,7.31195375 20.3749651,10.000031 C20.3749651,12.6881082 18.188054,14.8750194 15.4999768,14.8750194 C12.8118995,14.8750194 10.6249884,12.6881082 10.6249884,10.000031 C10.6249884,7.31195375 12.8118995,5.12504262 15.4999768,5.12504262 Z M15.4999768,13.2500232 C17.2920448,13.2500232 18.749969,11.792099 18.749969,10.000031 C18.749969,8.20796297 17.2920448,6.75003874 15.4999768,6.75003874 C13.7079087,6.75003874 12.2499845,8.20796297 12.2499845,10.000031 C12.2499845,11.792099 13.7079087,13.2500232 15.4999768,13.2500232 Z M15.4999768,0.25005424 C20.8847601,0.25005424 25.2499535,4.61524769 25.2499535,10.000031 C25.2499535,13.9311549 23.8804003,15.0289497 16.502061,25.7254192 C16.0178054,26.4248995 14.9820985,26.4248003 14.4979421,25.7254192 C7.11955316,15.0289497 5.75,13.9311549 5.75,10.000031 C5.75,4.61524769 10.1151934,0.25005424 15.4999768,0.25005424 Z M15.4999768,24.3167884 C22.5741748,14.0863746 23.6249574,13.2749179 23.6249574,10.000031 C23.6249574,7.82973282 22.7798285,5.78941252 21.2451871,4.25482069 C19.7105952,2.72017927 17.6702749,1.87505037 15.4999768,1.87505037 C13.3296786,1.87505037 11.2893583,2.72017927 9.75476645,4.25482069 C8.22012503,5.78941252 7.37499613,7.82973282 7.37499613,10.000031 C7.37499613,13.2751163 8.42642337,14.0873168 15.4999768,24.3167884 Z",
    id: "\\uF3C5"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.409be4c5.svg";
export { ForwardRef as ReactComponent };